const translations = {
  'paymentPlan.seo.title': 'TEFL Course Payment Plan Spain',
  'paymentPlan.seo.description':
    'Learn about our flexible payment plan for our TEFL courses in Barcelona, Spain. We aim to be open and accessible to every budget.',
  'paymentPlan.main.title': 'TEFL Course Payment Plan',
  'paymentPlan.sec1.title': 'How can I pay?',
  'paymentPlan.sec1.description':
    'Once your place on the course is confirmed we will send you a simple payment link where you can enter your credit / debit card details. If you would rather do a bank transfer we will include the necessary details',
  'paymentPlan.sec1.bot.title': 'TEFL Course Package Payment',
  'paymentPlan.sec1.bot.description':
    'We understand that these courses are a large investment and want to make them as accessible as possible to everyone. We offer the following payment plan:',
  'paymentPlan.sec1.ben1.title': 'Down payment',
  'paymentPlan.sec1.ben1.text': 'when you are accepted onto the course',
  'paymentPlan.sec1.ben2.title': 'First instalment',
  'paymentPlan.sec1.ben2.text': 'one month before your course starts',
  'paymentPlan.sec1.ben3.title': 'Final instalment',
  'paymentPlan.sec1.ben3.text': 'the Friday before the course starts',
  'paymentPlan.sec1.bot.text':
    'Please note the payment plan is only available on the full prices. If you would like the early bird / discounted rate you should pay your balance in full when you sign up.',
  'paymentPlan.sec2.title': 'TEFL & Student Visa / Spanish',
  'paymentPlan.sec2.description':
    ' We offer a similar payment plan whereby you pay in instalments, but please note your course fees must be paid in full at least two weeks before any appointment at the consulate to allow sufficient time to prepare and send documents. The Spanish Foreign Office requires that all course fees are paid in full before processing any student visas.',
  'paymentPlan.sec2.conditions': 'Payment terms and conditions',
  'paymentPlan.sec2.condText':
    'Please take a moment to read the <accentedLink> payment terms & conditions. </accentedLink>',
};

export default translations;
